import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Styled from './TransactionDetails.styled';
import { formatCurrency } from '../../features/passport/formatCurrency';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const OrderDetails = ({
  currencyCode,
  campaignLocale,
  orderItems,
  isOpen,
  id
}) => {
  const {
    t
  } = useTranslation(['blocks.transactionDetails', 'blocks.common']);
  return /*#__PURE__*/_jsx(Styled.OrderDetailsContainer, {
    id: id,
    isOpen: isOpen,
    numItems: orderItems?.length || 0,
    children: orderItems?.map(item => item.id && /*#__PURE__*/_jsxs(Styled.OrderDetail, {
      children: [/*#__PURE__*/_jsx(Styled.DesignationName, {
        children: item?.designationName || ''
      }), /*#__PURE__*/_jsx("div", {
        children: formatCurrency({
          currencyCode,
          amount: item.unitPrice || '0',
          locale: campaignLocale
        })
      }), /*#__PURE__*/_jsx(Styled.FrequencyBadge, {
        children: item.frequency && (item.endDate ? t('OrderDetails.frequencyWithEndDate', {
          frequency: item.frequency,
          /**
           * new Date('yyyy-mm-ddT00:00:00') will generate a date object for midnight
           * on the user's timezone, which will prevent a time shift when formatting it.
           */
          formattedDate: new Intl.DateTimeFormat('en-US').format(new Date(`${item.endDate}T00:00:00`)),
          defaultValue: '{{frequency}} until {{formattedDate}}'
        }) : t('OrderDetails.frequencyOnly', {
          frequency: item.frequency,
          defaultValue: '{{frequency}}'
        }))
      })]
    }, item.id))
  });
};